// src/config/moneris.js
// Configuration Moneris pour CoryntiQ
// ⚠️ REMPLACE les valeurs TEST par tes vraies credentials

const MONERIS_CONFIG = {
  // ============================================
  // ENVIRONNEMENT (changer en production)
  // ============================================
  environment: "sandbox", // 'sandbox' ou 'production'

  // ============================================
  // CREDENTIALS TEST (Sandbox) - CoryntiQ
  // ============================================
  sandbox: {
    storeId: "monca14126",
    apiToken: "8597612ac31e44bdaeec5a3697f463a0",
    hostedTokenizationProfileId: "htTBP2LKUBNLQTA",
    baseUrl: "https://esqa.moneris.com",
    hostedTokenizationUrl: "https://esqa.moneris.com/HPPtoken/index.php",
    gatewayUrl: "https://esqa.moneris.com/gateway2/servlet/MpgRequest",
  },

  // ============================================
  // CREDENTIALS PRODUCTION
  // ============================================
  production: {
    storeId: "REMPLACER_PAR_TON_STORE_ID_PROD",
    apiToken: "REMPLACER_PAR_TON_API_TOKEN_PROD",
    hostedTokenizationProfileId: "REMPLACER_PROD",
    baseUrl: "https://gateway.moneris.com",
    apiUrl: "https://www3.moneris.com/gateway2/servlet/MpgRequest",
    hostedTokenizationUrl: "https://www3.moneris.com/HPPtoken/index.php",
  },

  // ============================================
  // PLANS D'ABONNEMENT CORYNTIQ
  // ============================================
  plans: {
    essentiel: {
      id: "coryntiq_essentiel",
      name: "CoryntiQ Essentiel",
      priceMonthly: 199.0,
      priceAnnual: 1990.0,
      currency: "CAD",
      interval: "MONTH",
      intervalFrequency: 1,
      features: [
        "Tous les modules inclus",
        "Jusqu'à 3 utilisateurs",
        "Rapports standards",
        "Support par courriel (48h)",
      ],
    },
    professionnel: {
      id: "coryntiq_professionnel",
      name: "CoryntiQ Professionnel",
      priceMonthly: 449.0,
      priceAnnual: 4490.0,
      currency: "CAD",
      interval: "MONTH",
      intervalFrequency: 1,
      features: [
        "Tout dans Essentiel",
        "Utilisateurs illimités",
        "Rapports personnalisés",
        "Intégration API",
        "Support prioritaire (4h)",
        "1h d'onboarding incluse",
      ],
    },
  },

  // ============================================
  // CARTES DE TEST (Sandbox uniquement)
  // ============================================
  testCards: {
    visa: {
      number: "4242424242424242",
      expiry: "1228",
      cvv: "123",
      name: "Test Cardholder",
    },
    mastercard: {
      number: "5454545454545454",
      expiry: "1228",
      cvv: "123",
      name: "Test Cardholder",
    },
    declined: {
      number: "4502050000000008",
      expiry: "1228",
      cvv: "123",
      name: "Test Decline",
    },
  },
};

// ============================================
// HELPER FUNCTIONS
// ============================================

/**
 * Retourne la config active selon l'environnement
 */
export const getActiveConfig = () => {
  const env = MONERIS_CONFIG.environment;
  return {
    ...MONERIS_CONFIG[env],
    environment: env,
    plans: MONERIS_CONFIG.plans,
    testCards: env === "sandbox" ? MONERIS_CONFIG.testCards : null,
  };
};

/**
 * Retourne un plan par son ID
 */
export const getPlanById = (planId) => {
  return MONERIS_CONFIG.plans[planId] || null;
};

/**
 * Calcule le prix selon la fréquence de facturation
 */
export const calculatePrice = (planId, billingFrequency = "monthly") => {
  const plan = getPlanById(planId);
  if (!plan) return null;

  return billingFrequency === "annual" ? plan.priceAnnual : plan.priceMonthly;
};

/**
 * Génère un order ID unique
 */
export const generateOrderId = (prefix = "CORYNTIQ") => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 8).toUpperCase();
  return `${prefix}-${timestamp}-${random}`;
};

export default MONERIS_CONFIG;
